module.exports = __webpack_public_path__ + "img/state2.8a7a0dc7.webp";